import { render, staticRenderFns } from "./CategoryVoucherList.vue?vue&type=template&id=2816cbcc&"
import script from "./CategoryVoucherList.vue?vue&type=script&lang=js&"
export * from "./CategoryVoucherList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports